module.exports = __webpack_public_path__ + "static/media/star-exclamation.adee7b55.svg";